<template>
  <div class="about">
    <p>
      Qpic Virtual Festivalへようこそ！<br />
      九州大学物理研究部(Qpic)です！<br />
      Qpicとは、PCを使ったゲーム制作をはじめとして、プログラミング、イラストや音楽制作など、様々な活動を行っているサークルです。<br />
      例年は九大祭と呼ばれるイベントで部員が制作した作品を展示していましたが、昨年はコロナウイルスの影響により、九大祭が中止になってしまいました。<br />
      そこで、今回は九大祭での展示に代わる非公式イベントとして<b
        >Qpic Virtual Festival(QVF)</b
      >を開催することになりました！<br />
      テーマはズバリ、LightとDarkです！<br />
      この相反する二つのテーマを基に制作された、Qpic部員の個性あふれるゲーム、イラスト、音楽、シナリオを展示しています。<br />
      ぜひご覧になって下さい！<br />
    </p>
    <br />
    <br />
    <h2>- credits -</h2>
    <br />
    <br />
    <div class="other-info">
      <h2>Game</h2>
      <p v-for="content in games.neutral" :key="content.title">
        『{{ content.title }}』<br />
        <span v-for="member in content.member" :key="member">
          {{ member }}<br />
        </span>
      </p>
    </div>
    <CreditInfo :contents="graphics" title="Graphic"></CreditInfo>
    <CreditInfo :contents="musics" title="Music"></CreditInfo>
    <div class="other-info">
      <h2>マスタリング</h2>
      <p>teknizer</p>
    </div>
    <CreditInfo :contents="stories" title="Story"></CreditInfo>
    <div class="other-info">
      <h2>Web制作</h2>
      <p>Talisman<br />yuyu<br />AKADRA<br />せんき<br />iodo-shiba</p>
      <h2>Web背景デザイン</h2>
      <p>malcof</p>
    </div>
  </div>
</template>
<script>
import CreditInfo from "@/components/CreditInfo.vue";
export default {
  name: "Story",
  components: { CreditInfo },
  data() {
    return {
      games: this.$store.state.master?.games,
      graphics: this.$store.state.master?.graphics,
      musics: this.$store.state.master?.musics,
      stories: this.$store.state.master?.stories,
    };
  },
};
</script>
<style scoped lang="scss">
.about {
  font-size: 1.2em;
  line-height: 200%;
  overflow-y: scroll;
  padding: 5%;
  &::before {
    content: "";
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100vh;
    background-repeat: no-repeat;
    background-position: 50% 100%;
    background-image: url("../assets/qvf.png");
    background-color: rgba(255, 255, 255, 0.95);
    background-blend-mode: lighten;
    background-size: cover;
    position: fixed;
  }
}
.other-info {
  h2 {
    border-bottom: solid;
    padding: 1%;
    border-width: 1px;
    margin-bottom: 5%;
  }
  p {
    margin: 5%;
  }
  @media (max-width: 600px) {
    font-size: 0.8em;
  }
}
</style>
